export const SITE = {
  name: "Alisaafaat Welfare Foundation",
  shortName: "Alisaafaat",
  tagline: "Serving humanity with dignity.",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_de8261c7-36f3-4098-b6c5-e892a2e6504c/artifacts/gh2zy4i3_telegram-cloud-photo-size-4-5773981676164812679-y.jpg",
  email: "alisaafaatwelfare@gmail.com",
  officePhone: "09125397304",
  whatsapp: "09125397304",
  whatsappLink: "https://wa.me/2349125397304",
  offices: [
    "Kaka Oil, Old Egume Road, Anyigba, Dekina LGA, Kogi State",
    "Corner Shop Beside GAT Jumah'ah Mosque, NAIA Airport, Abuja",
  ],
  banks: [
    { name: "Jaiz Bank", account: "0018062227" },
    { name: "Zenith Bank", account: "1310267248" },
  ],
  accountName: "ALISAAFAAT WELFARE FOUNDATION",
  vision: "To create a society where everybody is valued.",
  mission: "To serve humanity with dignity.",
  verse: {
    text:
      "Those who spend their wealth in charity, by night and by day, secretly and openly — their reward is with their Lord; no fear shall come upon them, nor shall they grieve.",
    cite: "— Qur'an 2:274",
  },
};

export const NAV = [
  { id: "home", label: "Home", type: "scroll" },
  { id: "about", label: "About", type: "scroll" },
  { id: "causes", label: "Our Causes", type: "scroll" },
  { id: "programs", label: "Programs", type: "scroll" },
  { id: "mission", label: "Mission", type: "route", path: "/mission" },
  { id: "newsletter", label: "Newsletter", type: "route", path: "/newsletter" },
  { id: "donate", label: "Donate", type: "scroll" },
  { id: "contact", label: "Contact", type: "scroll" },
];

// --- Strategic Plan Content (2025–2035) ---
export const CORE_PURPOSES = [
  { icon: "BookOpen", text: "Promote knowledge through Islamic and secular education." },
  { icon: "HeartHandshake", text: "Provide care and support for orphans and vulnerable children." },
  { icon: "Sparkles", text: "Empower widows and women with economic and moral dignity." },
  { icon: "HandCoins", text: "Alleviate poverty through halal income and skill-building." },
  { icon: "Stethoscope", text: "Promote community health and well-being in underserved communities." },
  { icon: "Coins", text: "Distribute Zakat, Sadaqah, and Waqf in line with Shariah." },
  { icon: "Sun", text: "Foster ethical and spiritual development (Tarbiyah, Tazkiyah)." },
  { icon: "Users", text: "Strengthen community values, unity, and justice." },
];

export const SHORT_TERM_GOALS = [
  { goal: "Establish office", actions: "Set up admin team", timeline: "Q3 2025", kpi: "Office opened" },
  { goal: "Islamiyyah", actions: "Qur'an, Arabic, Tarbiyah", timeline: "Q1 2026", kpi: "200 children enrolled" },
  { goal: "Public Da'wah", actions: "Social media, radio, halaqahs", timeline: "Starting Q1 2026", kpi: "10,000+ reach" },
  { goal: "Orphan sponsorship", actions: "Care for 20 orphans", timeline: "Q1 2026", kpi: "10 orphans enrolled & tracked" },
  { goal: "Widows & women's skills", actions: "Sewing, soap-making classes", timeline: "Q4 2026", kpi: "20 women trained" },
  { goal: "Microfinance pilot", actions: "Qard Hasan to 30 families", timeline: "Q4 2026", kpi: "80% repayment rate" },
];

export const LONG_TERM_GOALS = [
  { goal: "Build permanent center", actions: "Masjid, school, orphanage, clinic", timeline: "2029 – 2034", kpi: "Land acquired, construction phases" },
  { goal: "Waqf projects", actions: "Farm, poultry, etc.", timeline: "Starting 2029, ongoing", kpi: "Self-sustaining income sources" },
  { goal: "Leadership & scholarship", actions: "Da'wah & social impact training", timeline: "2029, ongoing", kpi: "50+ youth trained" },
  { goal: "Orphanage expansion", actions: "Full care for 100+ orphans", timeline: "By 2031", kpi: "Residential care launched" },
  { goal: "Expansion", actions: "Open 3–5 new branches", timeline: "2030 – 2035", kpi: "Locations established in new areas" },
];

export const FUNDING_STRATEGY = [
  "Zakat & Sadaqah Drives",
  "Waqf Endowments",
  "Strategic partnerships (local & global Islamic organisations)",
  "Income-generating projects (farms, schools, workshops)",
];

export const MONITORING = [
  "Quarterly internal reviews",
  "Annual impact reports",
  "Financial audits",
  "Community feedback sessions",
];

// --- Newsletter posts (edit this array to publish updates) ---
const LEGACY_NEWSLETTER_POSTS = [
  {
    slug: "founding-of-alisaafaat",
    title: "Alisaafaat Welfare Foundation Begins Its Journey",
    excerpt:
      "We are honoured to introduce Alisaafaat Welfare Foundation — a charitable foundation dedicated to serving humanity with dignity through Zakat, Sadaqaat, and Waqf.",
    body:
      "Bismillāhir Raḥmānir Raḥīm. With deep gratitude to Allah, we announce the establishment of Alisaafaat Welfare Foundation. Our mission is to serve humanity with dignity — building a society where every soul is valued. Through your support, we will provide care to orphans, empower widows, and uplift communities across Nigeria.",
    image:
      "https://images.unsplash.com/photo-1694286068350-9a33dbaf476b?auto=format&fit=crop&w=1600&q=80",
    date: "2025-09-01",
    category: "Announcement",
  },
  {
    slug: "ramadan-iftar-drive",
    title: "Ramadan Iftar Drive — Reaching Families in Kogi & Abuja",
    excerpt:
      "Hot iftar meals and food packs delivered to over 100 less-privileged families during the blessed month.",
    body:
      "During the blessed month of Ramadan, our volunteers distributed iftar meals and dry food packs to families across Anyigba (Kogi State) and the FCT. We thank every donor whose Zakatul Fitr and Sadaqaat made this possible — your reward is with Allah.",
    image:
      "https://images.unsplash.com/photo-1776855828554-dfbeed18ffa2?auto=format&fit=crop&w=1600&q=80",
    date: "2025-10-15",
    category: "Field Update",
  },
  {
    slug: "orphan-sponsorship-launch",
    title: "Orphan Sponsorship Programme Launches",
    excerpt:
      "Our first cohort of orphans is now receiving full schooling, mentorship and monthly stipends.",
    body:
      "Insha'Allah, by Q1 2026 we will have 20 orphans enrolled under direct sponsorship — covering school fees, learning materials, healthcare and mentorship. Every sponsored child is tracked quarterly so donors can see their gift in action.",
    image:
      "https://images.unsplash.com/photo-1694286068158-836b3aec0599?auto=format&fit=crop&w=1600&q=80",
    date: "2025-11-20",
    category: "Programme",
  },
];

const CMS_CONTEXT = require.context("../content/newsletter", false, /\.json$/);
export function normalizeNewsletterPost(post, fallbackSlug = "") {
  const body = post.body || "";
  const image = post.image || "";
  return {
    ...post,
    slug: post.slug || fallbackSlug,
    category: post.category || "Field Update",
    excerpt: post.excerpt || `${body.slice(0, 180)}${body.length > 180 ? "..." : ""}`,
    image: image.startsWith("/uploads/")
      ? `https://raw.githubusercontent.com/AdigunQ/alisaafaat-foundation/main/frontend/public${image}`
      : image,
  };
}

const CMS_POSTS = CMS_CONTEXT.keys()
  .filter((key) => !key.endsWith("newsletter.json"))
  .map((key) => {
    const post = CMS_CONTEXT(key);
    const filename = key.replace(/^\.\//, "").replace(/\.json$/, "");
    return normalizeNewsletterPost(post, filename);
  });

export const NEWSLETTER_POSTS = CMS_POSTS.length ? CMS_POSTS : LEGACY_NEWSLETTER_POSTS;

export const CAUSES = [
  {
    title: "Zakatul Fitr",
    arabic: "زكاة الفطر",
    description:
      "The obligatory charity given at the end of Ramadan, ensuring no family goes without on the day of Eid.",
    img: "https://images.unsplash.com/photo-1694286068158-836b3aec0599?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Zakatul Mall",
    arabic: "زكاة المال",
    description:
      "An annual purification of wealth — 2.5% given to the rightful beneficiaries to uplift the ummah.",
    img: "https://images.unsplash.com/photo-1599659593072-10de2e109486?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Sadaqaat & Waqf",
    arabic: "صدقات و وقف",
    description:
      "Voluntary and endowment giving — distributed in line with Shariah for continuous, sustainable blessing.",
    img: "https://images.unsplash.com/photo-1776855828554-dfbeed18ffa2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Orphans & Widows",
    arabic: "الأيتام والأرامل",
    description:
      "Dedicated programs to feed, educate and empower the most vulnerable — restoring dignity and hope.",
    img: "https://images.unsplash.com/photo-1661865781226-bdea5c686d51?auto=format&fit=crop&w=1200&q=80",
  },
];

export const PROGRAMS = [
  {
    title: "Islamic & Secular Education",
    desc: "Qur'an, Arabic and Tarbiyah alongside formal education — building knowledge, faith and character in every child.",
    icon: "GraduationCap",
  },
  {
    title: "Orphan Sponsorship",
    desc: "Care, schooling and mentorship for orphans and vulnerable children — tracked and supported all year round.",
    icon: "Heart",
  },
  {
    title: "Widows & Women Empowerment",
    desc: "Skill acquisition (sewing, soap-making and more), micro-grants and trade kits to restore economic and moral dignity.",
    icon: "Sparkles",
  },
  {
    title: "Microfinance (Qard Hasan)",
    desc: "Interest-free pilot loans to low-income families — halal income, skill-building and a hand-up out of poverty.",
    icon: "HandCoins",
  },
  {
    title: "Community Health",
    desc: "Medical outreach, free check-ups and well-being campaigns reaching underserved communities with little access to care.",
    icon: "Stethoscope",
  },
  {
    title: "Da'wah & Tarbiyah",
    desc: "Social media, radio and community halaqahs — fostering ethical, spiritual development and unity in the ummah.",
    icon: "Users",
  },
];

export const IMPACT_STATS = [
  { value: "100+", label: "Beneficiaries reached" },
];

export const GALLERY = [
  "https://images.unsplash.com/photo-1694286068350-9a33dbaf476b?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1776855828554-dfbeed18ffa2?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1694286068158-836b3aec0599?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1599659593072-10de2e109486?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1661865781226-bdea5c686d51?auto=format&fit=crop&w=1000&q=80",
  "https://images.unsplash.com/photo-1709219378700-cc0cfc9aefe2?auto=format&fit=crop&w=1000&q=80",
];
